class ExpertsCarousel extends window.BAO.Carousel.Element {
  initialiseCarousel () {
    return new window.KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.1,
          spacing: 20,
        },
        breakpoints: {
          [`(min-width: ${window.BAO.MediaBreakpoints.breakpoints.sm}px)`]: {
            slides: {
              perView: 1.666,
              spacing: 40,
            },
          },
          [`(min-width: ${window.BAO.MediaBreakpoints.breakpoints.lg}px)`]: {
            slides: {
              perView: 2.666,
              spacing: 40,
            },
          },
          [`(min-width: ${window.BAO.MediaBreakpoints.breakpoints.xxlg}px)`]: {
            disabled: true,
          },
        },
      },
      [window.BAO.Carousel.useInitialised()],
    )
  }
}

if (!customElements.get('experts-carousel')) {
  customElements.define('experts-carousel', ExpertsCarousel)
}
